import { useModal } from "@/hooks/useModal";

export default function CTASection() {
  const { openQuote } = useModal();

  return (
    <section className="w-full py-16 md:py-24 bg-brand-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" />
      </div>
      <div className="relative z-10 px-4 md:px-6 lg:px-8 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
          Ready to Secure &amp; Scale Your IT?
        </h2>
        <p className="text-sm md:text-base text-brand-100 max-w-lg mx-auto mb-8">
          Book a free consultation and discover how Presuni can transform your technology stack.
        </p>
        <button
          onClick={openQuote}
          className="px-8 py-3.5 rounded-full bg-white text-brand-600 text-sm font-semibold hover:bg-brand-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
        >
          Get a Quote
        </button>
      </div>
    </section>
  );
}